/* eslint global-require: "off" */
import { merge } from 'lodash';

function computeResourcePage(names, name, parent) {
  return {
    meta: {
      index: {
        title: `${names} / ${parent}`,
        breadcrumb: `${names}`,
        tab: `${names} / ${parent}`,
      },
      create: {
        title: `Nouveau(elle) ${name} / ${parent}`,
      },
      show: {
        title: `{label} / ${names} / ${parent}`,
        breadcrumb: '{label}',
        tab: `{label} / ${names} / ${parent}`,
      },
      edit: {
        title: `Éditer {label} / ${names} / ${parent}`,
      },
    },
  };
}

export default {
  ...merge(
    {},
    require('./admin/users').default,
    require('./site/users').default,
    require('./formaat/clients').default,

    {
      pages: {
        formaat: {
          clients: computeResourcePage('Clients', 'client', 'Formaât'),
        },
        admin: {
          users: computeResourcePage('Administrateurs', 'administrateur', 'Administration'),
        },
        site: {
          users: computeResourcePage('Utilisateurs', 'utilisateur', 'Administration'),
        },
      },
    },
  ),
};
